import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { useAbilityContext } from '../../../../../components/Can/Can';
import { Action } from '../../../../../enums/action';
import { PAGE_TITLE } from '../../../../../constants/common';
import ROUTE from '../../../../../constants/route-constants';
import { IOverviewTopActions } from '../interfaces/IOverviewTopActions';

export const useOverviewTopActions = (): IOverviewTopActions => {
  const { clientId } = useParams();
  const navigate = useNavigate();

  const ability = useAbilityContext();

  const handleCreateCycle = useCallback(() => {
    const path = generatePath(ROUTE.ADD_CYCLE_BY_LOCATION, { clientId });
    navigate(path);
  }, [clientId, navigate]);

  const handleCreateScreen = useCallback(() => {
    const path = generatePath(ROUTE.CREATE_SCREEN_BY_LOCATION, { clientId });
    navigate(path);
  }, [clientId, navigate]);

  return {
    canCreateCycle: ability.can(Action.Read, PAGE_TITLE.ADD_CYCLE),
    canCreateScreen: ability.can(Action.Read, PAGE_TITLE.CREATE_SCREEN),
    handleCreateCycle,
    handleCreateScreen,
  };
};
